export enum EPropertyUrl {
  PROPERTIES = 'properties',
  SEARCH = 'search',
  UNITS = 'units',
}
